<template>
    <div class="baseInfo">
        <div class="manage-main">
            <div class="rule" style="display: flex;background: #fff;">
                <Menu></Menu>
                <div class="manage-right">
                    <div class="right-top">
                    <div class="right-title">修改密码</div>
                    <div class="change-pass">
                        <div class="input-box">
                            <span class="input-label">旧密码</span>
                            <input type="password" v-model="OldPwd" maxlength="20">
                            <i v-if="OldPwd!=''" class="iconfont icon-guanbi" @click="OldPwd=''"></i>
                        </div>
                        <div class="input-box">
                            <span class="input-label">新密码</span>
                            <input type="password" v-model="NewPwd" maxlength="20">
                            <i v-if="NewPwd!=''" class="iconfont icon-guanbi" @click="NewPwd=''"></i>

                        </div>
                        <div class="input-box">
                            <span class="input-label">确认密码</span>
                            <input type="password" v-model="ConfirmPwd" maxlength="20">
                            <i v-if="ConfirmPwd!=''" class="iconfont icon-guanbi" @click="ConfirmPwd=''"></i>
                            <span v-if="isErrorT" style="color: red">两次输入密码不一样</span>
                        </div>
                        <div class="input-box">
                            <span class="input-label"></span>
                            <div class="submit-btn" @click="submit()">提交</div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Menu from './../../common/cmpnt/menu/Menu'

    export default {
        name: "ResetPassword",
        components: {
            Menu
        },
        data: function () {
            return {
                ConfirmPwd: '',
                OldPwd: '',
                NewPwd: '',
                isErrorT:false,
            }
        },
        mounted() {
            document.title='修改密码---云境';
        },
        methods: {
            submit() {
                var that = this;
                if (!that.OldPwd) {
                    that.error({title: '提示', content: '旧密码不能为空！'})
                    return
                }
                if (!that.NewPwd) {
                    that.error({title: '提示', content: '新密码不能为空！'})
                    return
                }
                if (!that.ConfirmPwd) {
                    that.error({title: '提示', content: '确认密码不能为空！'})
                    return
                }
                if(that.ConfirmPwd != that.NewPwd){
                    that.isErrorT = true;
                    return
                }else{
                    that.isErrorT = false;
                }
                var params = {
                    ConfirmPwd: that.ConfirmPwd,
                    OldPwd: that.OldPwd,
                    NewPwd: that.NewPwd,
                }
                that.patchRequest({
                    url: that.Api.changePwd,
                    params: params
                }).then(res => {
                    if (res.IsSuccess) {
                        that.error({title: '提示', content: '修改成功'})
                    } else {
                        that.error({title: '提示', content: res.Msg})
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/account/ResetPassword.vue